/**** mgt.ControlRegion */

const config = {
  schema: 'mgt',
  table: 'ControlRegion',
  title: 'Районы контроля',
  elemsOnPage: 100,
  connections: {
    department: {
      schema: 'mgt',
      table: 'Department',
      index: 'td_id',
      fields: ['td_name'],
      format: (elem: any) => elem['td_name'],
      autocomplete: false,
    },
  },
  fields: [
    {
      name: 'cd_id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
      hide: true,
    },
    {
      name: 'cd_name',
      title: 'Наименование',
      type: 'text',
      required: true,
      hide: true,
    },
    {
      name: 'td_id',
      title: 'Территориальный отдел',
      type: 'number',
      required: false,
      connection: 'department',
      link: 'department',
    },
    {
      name: 'geom',
      title: 'Зона',
      type: 'map',
      composite: {
        type: 'polygon'
      },
      required: true,
      disableFilter: true,
    },
  ],
  defaultSort: {
    field: 'cd_id',
    direction: 'desc',
  },
  makeTitle: (elem: any, connections: { [key: string]: any }): string => {
    return `${elem['cd_name']}`;
  },
  makeAdditional: (elem: any, connections: { [key: string]: any }): string => {
    const td =
      connections &&
      connections['department'] &&
      connections['department'].find(
        (dp: any) => dp['td_id'] === elem['td_id']
      );
    return `Территориальный отдел: ${(td && td['td_name']) || '-'}`;
  },
};

export default config;
